import { useCallback } from "react";
import { SuppliersApi, useAPIAction } from "melco-shared-logic";

export interface UpdateExistingSupplierProductButtonInterface {
  id: string;
  name: string;
  code: string;
}

export const useUpdateExistingSupplierProductDraft = () => {
  const [UpdateExistingSupplierProductDraft] = useAPIAction(
    SuppliersApi,
    async (
      api,
      UpdateExistingSupplierProductData: UpdateExistingSupplierProductButtonInterface
    ) => {
      const data = await api.supplierProductDraftUpdate({
        id: UpdateExistingSupplierProductData.id,
        controlcenterMelcoModelsUpdateSupplierProduct: {
          name: UpdateExistingSupplierProductData.name,
          code: UpdateExistingSupplierProductData.code,
        },
      });

      return {
        successMessages: [],
        data,
      };
    },
    {
      skipErrorHandling: true,
      translationPrefix: "supplierproducts.actions.save",
    }
  );

  return useCallback(
    async (
      UpdateActionDetails: UpdateExistingSupplierProductButtonInterface
    ) => {
      return await UpdateExistingSupplierProductDraft(UpdateActionDetails);
    },
    [UpdateExistingSupplierProductDraft]
  );
};
